<template>
  <el-container class="full-content" id="app">
    <el-header class="flex-row-between header_app" style="border-bottom: 1px solid #ebebeb;height:80px;">
      <div v-if="!$Demo">
        <div class="app_menu2_click_logo"> <img :src="$Image('logo.png')" alt=""></div>
        <div :class="this.isLogined===true ? 'app_menu2_click' : 'app_menu2_click_none'" @click="OnMenuOne(true)"> <img :src="$Image('menu1.png')" alt=""></div>
        <div :class="this.isLogined===false ? 'app_menu2_click_logo2' : 'app_menu2_click_none'"> <img :src="$Image('logo.png')" alt=""></div>
      </div>
      <div v-else>
        <div class="app_menu2_click" @click="OnMenuOne(true)"> <img :src="$Image('menu1.png')" alt=""></div>
        <div class="app_menu2_click_log"> <img :src="$Image('logo.png')" alt=""></div>
      </div>
      <span class="app_show_router_name">{{RouterLists}}</span>
      <div class="app_hide_menu2">
        <div class="flex-row-start">
          <el-button @click="DownloadMobileApp" round class="otherBtn" style="width:200px;height:40px;">{{$t('Download Mobile App')}}</el-button>
          <el-button @click="BuyNow" type="success" round class="normalBtn" style="margin-left:14px;width:110px;height:40px;">{{$t('Buy Now')}}</el-button>
          <div style="margin-left:40px;">
            <languageChange></languageChange>
          </div>
          <div v-if="$Demo" @click="tryItNow"> <a class="contant-us">{{$t('Try it now')}}</a></div>
          <div class="contant-us" @click="onContentUS">{{$t('Contact Us')}}</div>
        </div>
      </div>
      <div class="app_menu2_clickTwo" @click="OnMenuTwo"> <img :src="$Image('menu2.png')" alt=""></div>
      <div v-if="ShowMenuTwo" class="app_show_menu2">
        <div class="app_menu2_click_lang">
          <languageChange></languageChange>
        </div>
        <a v-if="$Demo" @click="tryItNow" class="contant_us app_menu2_click_lang">{{$t('Try it now')}}</a>
        <div class="contant_us app_menu2_click_lang" @click="onContentUS">{{$t('Contact Us')}}</div>
        <el-button @click="BuyNow" type="success" round class="normalBtn" style="width:176px;height:36px;margin-top:20px;margin-bottom:20px">{{$t('Buy Now')}}</el-button>
        <el-button @click="DownloadMobileApp" round class="otherBtn" style="width:176px;height:36px;margin-left:0;">{{$t('Download Mobile App')}}</el-button>
      </div>
    </el-header>
    <el-main class="">
      <router-view v-if="isRouterAlive"></router-view>
    </el-main>
  </el-container>
</template>

<script>
import languageChange from './components/Common/languageChange.vue'
import { mapState } from 'vuex'
import * as Mutations from './store/mutations'
import { tryItNow } from './components/api/cookies.js'
export default {
  name: 'App',
  provide: function () {
    return {
      'rootMenu': this,
      reload: this.reload
    }
  },
  data () {
    return {
      RouterLists: '',
      ShowMenuTwo: false,
      SelectMenuOne: false,
      ShowLogo: false,
      isRouterAlive: true
    }
  },
  components: {languageChange},
  computed: {
    ...mapState([
      'isLogined'
    ])
  },
  methods: {
    tryItNow () {
      tryItNow()
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    OnMenuOne (type) {
      // console.log(this.isLogined)
      if (type) {
        this.SelectMenuOne = !this.SelectMenuOne
        // this.SelectMenuOne = true
      }
      this.$emit('OnMenuOne', this.SelectMenuOne)
    },
    OnMenuTwo () {
      console.log('show')
      this.ShowMenuTwo = !this.ShowMenuTwo
    },
    onContentUS () {
      window.open('https://famikit.com/contact.html')
    },
    DownloadMobileApp () {
      window.open('https://famikit.com/download.html')
    },
    BuyNow () {
      window.open('https://famikit.com/pricing.html')
    }
  },
  mounted () {
    console.log(this.isLogined)
    console.log(this)
    // if (this.isLogined === true) {
    //   this.ShowLogo = true
    // }
    let EmailDate = sessionStorage.getItem('Email')
    console.log(sessionStorage.getItem('Email'), EmailDate)
    if (EmailDate === null) {
      this.$store.commit(Mutations.login, {type: false})
    } else {
      this.$store.commit(Mutations.login, {type: true})
    }
    // window.onbeforeunload = function (e) {
    //   let storage = window.sessionStorage
    //   storage.clear()
    // }
  },
  beforeDestroy () {
    let storage = window.sessionStorage
    storage.clear()
  },
  created () {
    // if (this.isLogined === false) {
    //   this.ShowLogo = true
    // } else {
    //   this.ShowLogo = false
    // }
  },
  watch: {
    '$route' (to, from) {
      var RouterList = to.name
      console.log(RouterList)
      this.RouterLists = RouterList
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  box-sizing: border-box;
}
.contant-us{
  font-size: 14px;
  color: #888888;
  margin-left:38px;
  text-decoration:underline;
  cursor: pointer;
}
.contant_us{
  font-size: 14px;
  color: #888888;
  text-decoration:underline;
  cursor: pointer;
}
.app_menu2_click, .app_menu2_clickTwo{
  cursor: pointer;
}
.header_app {
  position: relative;
}
.app_show_menu2 {
  position: absolute;
  top: 80px;
  right: 0;
  height: 300px;
  width: 180px;
  padding: 0 20px;
  background-color: #fff;
  display: -moz-box;  /* Firefox */
  display: -ms-flexbox;    /* IE10 */
  display: -webkit-box;    /* Safari */
  display: -webkit-flex;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  box-shadow: 1px 2px 4px 0px rgba(0, 0, 0, 0.12);
  z-index: 10;
}
.app_menu2_click_lang{
  padding: 20px 0;
  width: 100%;
  text-decoration:none;
  border-bottom: 1px solid #ececec;
}
.app_show_router_name, .app_menu2_click, .app_menu2_clickTwo, .app_menu2_click_none{
  display: none;
}
.app_menu2_click_logo, .app_hide_menu2{
  display: block;
}
.app_menu2_click_logo2 {
  display: none;
}
@media (max-width: 1024px){
  .app_menu2_click_log {
    display: none;
  }
  .app_show_router_name, .app_menu2_click, .app_menu2_clickTwo{
    display: block;
  }
  .app_menu2_click_logo, .app_hide_menu2{
    display: none;
  }
  .app_menu2_click_logo2 {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue